// Angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Constant imports
import { StringFormatConstants } from '../../../_constants/string-format-constants';

// Model imports
import { AccHistoryResultDto } from '../../_models/acc-history-result-dto';

@Component({
    selector: 'app-architectural-application-transaction-log',
    templateUrl: './architectural-application-transaction-log.component.html',
    styleUrls: ['./architectural-application-transaction-log.component.scss']
})
export class ArchitecturalApplicationTransactionLogComponent {
    @Input() visible: boolean;
    @Input() title: string;
    @Input() transactionLogResultData: AccHistoryResultDto[] = [];
    @Output() onTransactionLogClose = new EventEmitter<boolean>();

    iconClose = IconConstants.CLOSE;
    dateTimeFormat = StringFormatConstants.dateTimeFormat;

    onPopClose(): void {
        this.visible = false;
        this.onTransactionLogClose.emit(this.visible);
    }
}
